import Vue from 'vue'
import moment from 'moment-mini'
import numeral from 'numeral'
import marked from 'marked'
import parsePhoneNumber from 'libphonenumber-js'

import _find from 'lodash/find'
import _includes from 'lodash/includes'
import _replace from 'lodash/replace'

Vue.filter(
  'moment',
  (value, format = 'MMM D, YYYY', opts = { naive: false }) => {
    if (!value) return null
    return opts.naive
      ? moment.utc(value).format(format)
      : moment.utc(value).local().format(format)
  }
)

Vue.filter('moment_unix', (value, format) => {
  if (!value) return null
  format || (format = 'MMM D, YYYY')
  return moment.unix(value).local().format(format)
})

// Vue.filter("moment_unixFromNow", (value) => {
//   if (!value) return null
//   return moment
//     .unix(value)
//     .local()
//     .fromNow()
// })

// Vue.filter("moment_fromNow", (value) => {
//   if (!value) return null
//   return moment
//     .utc(value)
//     .local()
//     .fromNow()
// })

// Vue.filter("date", (value, format) => {
//   if (!value) return null
//   format || (format = "MMM D, YYYY")
//   return moment
//     .utc(value)
//     .local()
//     .format(format)
// })

// Vue.filter("date_unix", (value, format) => {
//   if (!value) return null
//   format || (format = "MMM D, YYYY")
//   return moment.unix(value).format(format)
// })

// Vue.filter("duration", (value, format) => {
//   if (!value) return null
//   format || (format = "HH:mm:ss")
//   return moment
//     .utc(moment.duration(value, "seconds").asMilliseconds())
//     .format(format)
// })

Vue.filter('lowercase', (value) => (value ? value.toLowerCase() : null))

Vue.filter('price', (value, format) => numeral(value).format(format || '$0,0'))
Vue.filter('number', (value, format) => numeral(value).format(format || '0,0'))

Vue.filter('phone', (value) => {
  if (!value) {
    return
  }

  const regexPattern = /^\+|\d*/g

  const cleanValue = value
    ? new RegExp(regexPattern).test(value)
      ? value.match(regexPattern).join('')
      : ''
    : ''

  // Assume US for national numbers (no country code)
  const parsedValue = parsePhoneNumber(cleanValue, 'US')

  if (parsedValue) {
    if (parsedValue.country === 'US') {
      // Format in NANP
      const nationalNumber = parsedValue.nationalNumber
      return `(${nationalNumber.slice(0, 3)}) ${nationalNumber.slice(
        3,
        6
      )}-${nationalNumber.slice(6, 10)}`
    } else {
      // Format using international format
      return `+${parsedValue.countryCallingCode} ${parsedValue.nationalNumber}`
    }
  } else {
    return cleanValue
  }
})

Vue.filter('markdown', (value) => (value ? marked(value) : null))

Vue.filter('replace', (string, pattern, replacement) =>
  _replace(string, pattern, replacement)
)

Vue.filter('estimatedDate', (value) => {
  if (value) {
    const date = moment.utc(value)
    const diff = date.diff(moment.utc(), 'months')
    const month = date.format('MMM')
    if (diff >= 6) {
      if (_includes(['Dec', 'Jan', 'Feb'], month)) {
        return `Winter, ${date.format('YYYY')}`
      }
      if (_includes(['Mar', 'Apr', 'May'], month)) {
        return `Spring, ${date.format('YYYY')}`
      }
      if (_includes(['Jun', 'Jul', 'Aug'], month)) {
        return `Summer, ${date.format('YYYY')}`
      }
      if (_includes(['Sep', 'Oct', 'Nov'], month)) {
        return `Fall, ${date.format('YYYY')}`
      }
    }
    if (diff < 6 && diff > 0) return date.format('MMMM, YYYY')
    if (diff <= 0) return date.format('MMM D, YYYY')
  } else {
    return '??'
  }
})

const constructionPhaseMap = [
  { id: 'PLANNING', class: 'planning', label: 'Planning' },
  { id: 'SITE_WORK', class: 'site-work', label: 'Site Work' },
  { id: 'FOUNDATION', class: 'foundation', label: 'Foundation' },
  { id: 'FRAMING', class: 'framing', label: 'Framing' },
  { id: 'ENVELOPE', class: 'envelope', label: 'Envelope' },
  { id: 'ROUGH_MEP', class: 'rough-mep', label: 'Rough MEP' },
  { id: 'DRYWALL', class: 'drywall', label: 'Drywall' },
  { id: 'FINISHES', class: 'finishes', label: 'Finishes' },
  { id: 'FINISH_MEP', class: 'finish-mep', label: 'Finish MEP' },
  { id: 'COMPLETED', class: 'completed', label: 'Completed' }
]

Vue.filter('constructionPhaseLabel', (value) => {
  if (value) {
    const item = _find(constructionPhaseMap, { id: value })
    return item ? item.label : '??'
  } else {
    return '??'
  }
})

Vue.filter('constructionPhaseClass', (value) => {
  if (value) {
    const item = _find(constructionPhaseMap, { id: value })
    return item ? item.class : '??'
  } else {
    return '??'
  }
})

const documentTypeMap = [
  { id: 'ADDENDUM', class: 'addendum', label: 'Addendum' },
  {
    id: 'AGREEMENT_OF_SALE',
    class: 'agreement-of-sale',
    label: 'Agreement of Sale'
  },
  { id: 'APPRAISAL', class: 'appraisal', label: 'Appraisal' },
  { id: 'HOA', class: 'hoa', label: 'HOA' },
  { id: 'MISC', class: 'misc', label: 'Misc.' },
  {
    id: 'MORTGAGE_COMMITMENT',
    class: 'mortgage-commitment',
    label: 'Mortgage Commitment'
  },
  {
    id: 'MORTGAGE_PREAPPROVAL',
    class: 'mortgage-preapproval',
    label: 'Mortgage Preapproval'
  },
  { id: 'INVOICE', class: 'invoice', label: 'Invoice' },
  { id: 'WARRANTY', class: 'warranty', label: 'Warranty' }
]

Vue.filter('documentTypeLabel', (value) => {
  if (value) {
    const item = _find(documentTypeMap, { id: value })
    return item ? item.label : '??'
  } else {
    return '??'
  }
})

Vue.filter('retention', (score) => {
  if (score !== null) {
    return score >= 50
      ? 'Unicorn'
      : score >= 35
      ? 'Excellent'
      : score >= 20
      ? 'Very Good'
      : score >= 10
      ? 'Good'
      : score >= 0
      ? 'Ok'
      : 'Poor'
  } else {
    return '??'
  }
})

Vue.filter('amenity', ({ amenity, nameOverride }) => {
  if (nameOverride) {
    return nameOverride
  } else {
    const amenityMap = {
      BUSINESS_CENTER: 'Business center',
      BICYCLE_STORAGE: 'Bicycle storage',
      CONCIERGE: 'Concierge',
      EV_CHARGING_STATIONS: 'EV charging',
      GAME_SPACE: 'Game space',
      LOUNGE: 'Lounge',
      OUTDOOR_POOL: 'Outdoor pool',
      MARINA: 'Marina',
      MEDIA_ROOM: 'Media room',
      RESTAURANT: 'Restaurant',
      SPA: 'Spa',
      VALET: 'Valet',
      WATERSPORT_STORAGE: 'Watersport storage',
      WINE_CELLAR: 'Wine cellar'
    }
    return amenityMap[amenity] || amenity
  }
})
